export function identity<A>(value: A): A {
  return value
}
